import { render, staticRenderFns } from "./ModalComponent.vue?vue&type=template&id=cc25a720&scoped=true&"
import script from "./ModalComponent.vue?vue&type=script&lang=ts&"
export * from "./ModalComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ModalComponent.vue?vue&type=style&index=0&id=cc25a720&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc25a720",
  null
  
)

export default component.exports